import http from '../interceptors/Intercepter';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const retrieveParticipants = async (username) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.get('/api/participant/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewDropdownParticipants = async (username, viewParticipantForDropdownRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/view/dropdown', viewParticipantForDropdownRequest, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewParticipant = async (username, participantExternalReference) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post(
      '/api/participant/view/participant',
      { participantExternalReference },
      { params, ...config }
    );

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewParticipantVisitCodes = async (username, findVisitCodesRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/retrieve/visit-codes', findVisitCodesRequest, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const logParticipantVisit = async (username, logVisitRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/log-visit', logVisitRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewParticipantPastVisit = async (username, retrieveVisitRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/retrieve/visit', retrieveVisitRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateParticipantPastVisit = async (username, updateVisitRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/update/visit', updateVisitRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteParticipantPastVisit = async (username, deleteVisitRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/delete/visit', deleteVisitRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateParticipantLocation = async (username, updateParticipantLocationRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.put('/api/participant/update/location', updateParticipantLocationRequest, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteParticipant = async (username, participantExternalReference) => {
  try {
    const params = {
      participantExternalReference: participantExternalReference,
      username: username,
    };

    const { data } = await http.delete('/api/participant/delete', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateParticipantStatus = async (username, updateParticipantStatusRequest) => {
  try {
    const params = { username };

    const { data } = await http.put('/api/participant/status', updateParticipantStatusRequest, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const populateVisitToCapture = async (username, participantExternalReference, date) => {
  try {
    const params = { username, participantExternalReference, date };

    const { data } = await http.get('/api/participant/populate/visit-to-capture', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const logMissedVisit = async (username, requestData) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/participant/log-missed-visit', requestData, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const changeParticipantSchedule = async (username, changeScheduleRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/participant/change-schedule', changeScheduleRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
